import React, { useRef, useState, useEffect } from 'react';
import styles from "./contact.module.scss";
import { motion } from "framer-motion";
import emailjs from 'emailjs-com';

import FileDownloadIcon from '@mui/icons-material/FileDownload';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import MyPhoto from "../../assets/My_profile.png";
import Resume from "../../assets/MANSI_PATIL_.pdf";

const Contact = () => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setOpen(false);
        }, 3000);

        return () => {
            clearTimeout(timer);
        };
    }, [open]);

    const form = useRef();

    const [formData, setFormData] = useState({
        user_name: '',
        user_email: '',
        message: ''
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        let temp_errors = { ...errors };
        delete temp_errors[name];
        setErrors(temp_errors);
        setFormData({ ...formData, [name]: value });
    };

    const validateForm = () => {
        const newErrors = {};
        if (formData.user_name.trim() === '') {
            newErrors.user_name = 'Name is required';
        }
        if (formData.message.trim() === '') {
            newErrors.message = 'Message is required';
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!formData.user_email.trim()) {
            newErrors.user_email = 'Email is required';
        } else if (!emailRegex.test(formData.user_email)) {
            newErrors.user_email = 'Invalid email address';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const sendEmail = (e) => {
        e.preventDefault();
        if (validateForm()) {
            emailjs.sendForm('service_29kcp99', 'template_7uy2638', form.current, 'qqqhqlC3xZ2bQl33Q')
                .then(() => {
                    setOpen(true);
                    setFormData({
                        user_name: '',
                        user_email: '',
                        message: ''
                    });
                }, (error) => {
                    console.error('Failed to send email:', error.text);
                });
        }
    };

    return (
        <motion.section
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{
                duration: 0.8,
                delay: 1 / 10,
                type: "spring",
                stiffness: 80,
                damping: 15
            }}
            className={`${styles.contact} flex items-center justify-center min-h-screen`}
            id="contact"
        >
            <Snackbar
                open={open}
                autoHideDuration={3000}
                onClose={() => setOpen(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={() => setOpen(false)} severity="success" sx={{ width: '100%' }}>
                    Email sent successfully!
                </Alert>
            </Snackbar>
            <div className={`${styles.contact_card} relative w-full max-w-xl`}> {/* Increased max width */}
                <div className={`${styles.lightning_effect}`}></div>
                <div className="flex flex-col items-center text-center mb-4">
                    <img src={MyPhoto} alt="Mansi Patil" className="rounded-full w-50 h-40 mb-3" />
                    <h2 className="text-white text-lg font-bold">Mansi Patil</h2>
                    <p className="text-secondary text-sm">patil.mansi.narendra@gmail.com</p>
                    <div className="flex space-x-3 mt-3">
                        <a href="https://www.linkedin.com/in/mansi-patil28/" rel="noreferrer" target="_blank" aria-label="LinkedIn">
                            <LinkedInIcon className="text-white" />
                        </a>
                        <a href="https://github.com/mansi2804" rel="noreferrer" target="_blank" aria-label="GitHub">
                            <GitHubIcon className="text-white" />
                        </a>
                    </div>
                    <a
                        href={Resume}
                        rel="noreferrer"
                        target="_blank"
                        className="mt-3 inline-block bg-secondary text-white py-1 px-3 rounded-lg shadow-md text-xs"
                        aria-label="Download Resume"
                    >
                        Download Resume <FileDownloadIcon />
                    </a>
                </div>
                <h2 className="text-white text-center text-xl font-bold mb-4">Contact Me</h2>
                <form ref={form} onSubmit={sendEmail} className="flex flex-col items-center">
                    <div className="relative mb-4 w-full max-w-xs">
                        <input
                            type="text"
                            name="user_name"
                            value={formData.user_name}
                            onChange={handleChange}
                            placeholder="Your Name *"
                            className={`py-3 px-4 w-full placeholder-transparent text-white rounded-lg outline-none border-none font-bold ${styles.glassy_input}`}
                        />
                        <label
                            htmlFor="user_name"
                            className="absolute left-4 top-3 text-secondary text-sm transition-all duration-300 ease-in-out pointer-events-none"
                        >
                            Your Name *
                        </label>
                        <span className={errors.user_name ? `visible text-error mt-1` : `invisible`}>
                            {errors.user_name}
                        </span>
                    </div>
                    <div className="relative mb-4 w-full max-w-xs">
                        <input
                            type="email"
                            name="user_email"
                            value={formData.user_email}
                            onChange={handleChange}
                            placeholder="Your Email *"
                            className={`py-3 px-4 w-full placeholder-transparent text-white rounded-lg outline-none border-none font-bold ${styles.glassy_input}`}
                        />
                        <label
                            htmlFor="user_email"
                            className="absolute left-4 top-3 text-secondary text-sm transition-all duration-300 ease-in-out pointer-events-none"
                        >
                            Your Email *
                        </label>
                        <span className={errors.user_email ? `visible text-error mt-1` : `invisible`}>
                            {errors.user_email}
                        </span>
                    </div>
                    <div className="relative mb-4 w-full max-w-xs">
                        <textarea
                            rows="4"
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            placeholder="Your Message *"
                            className={`py-3 px-4 w-full placeholder-transparent text-white rounded-lg outline-none border-none font-bold ${styles.glassy_input}`}
                        ></textarea>
                        <label
                            htmlFor="message"
                            className="absolute left-4 top-3 text-secondary text-sm transition-all duration-300 ease-in-out pointer-events-none"
                        >
                            Your Message *
                        </label>
                        <span className={errors.message ? `visible text-error mt-1` : `invisible`}>
                            {errors.message}
                        </span>
                    </div>
                    <button
                        type="submit"
                        className={`py-2 px-6 rounded-lg outline-none text-white font-bold shadow-md shadow-primary transition-transform transform hover:scale-105 mx-auto text-sm ${styles.glassy_button}`}
                    >
                        Send
                    </button>
                </form>
            </div>
        </motion.section>
    );
};

export default Contact;